import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { UserService } from '../../services/user/UserService'
import { UserState } from './types'

const initialState: UserState = {
  isActive: true,
  userImage: null,
  users: [],
  userInfo: undefined,
  isUsersLoading: false,
  isStartResetPassword: false
}

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserImage: (state, action: PayloadAction<File>) => {
      state.userImage = action.payload
    },
    toggleUserActive: (state) => {
      state.isActive = !state.isActive
    },
    setIsStartResetPassword: (state, action: PayloadAction<boolean>) => {
      state.isStartResetPassword = action.payload
    },
    resetUserState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(UserService.getAllUserAsyncThunk.pending, (state) => {
      state.isUsersLoading = true
    })
    builder.addCase(UserService.getAllUserAsyncThunk.rejected, (state) => {
      state.isUsersLoading = false
    })
    builder.addCase(UserService.getAllUserAsyncThunk.fulfilled, (state, action) => {
      state.isUsersLoading = false
      state.users = action.payload
    })
    builder.addCase(UserService.getUserByIdAsyncThunk.fulfilled, (state, action) => {
      state.userInfo = action.payload
      state.isActive = action.payload.isActive
    })
  }
})

export const { setUserImage, toggleUserActive, resetUserState, setIsStartResetPassword } = slice.actions
export default slice.reducer
